// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Documents_wrap__l-8VL","footer":"Documents_footer__3xT2c"};